import { render, staticRenderFns } from "./TwodThreed.vue?vue&type=template&id=6011d2de&scoped=true"
import script from "./TwodThreed.vue?vue&type=script&lang=js"
export * from "./TwodThreed.vue?vue&type=script&lang=js"
import style0 from "./TwodThreed.vue?vue&type=style&index=0&id=6011d2de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6011d2de",
  null
  
)

export default component.exports